module.exports = __webpack_public_path__ + "assets/images/01L.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01L.png
// module id = 1256
// module chunks = 1